// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"331":"date-selector","968":"OrderPayments"}[chunkId] || chunkId) + "." + {"126":"37cc676405f672406fde","331":"20e3379d324c60af7a25","968":"33c8a779953785768cd7"}[chunkId] + ".chunk.css";
};